import React from 'react';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.fluent.saas.light.css';
import './css/styles.css'
// import './themes/generated/theme.additional.css';

import { BrowserRouter as Router } from 'react-router-dom';
import { NavigationProvider } from './contexts/navigation';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { useScreenSizeClass } from './utils/media-query';
import Content from './layouts/content/Content';
import { ThemeContext, useThemeContext } from "./theme";
import LoginPage from "./pages/login/index";

const ProtectedRoute = () => {
  const { user } = useAuth();

  if (user) {
    return <Content />;
  }

  return <LoginPage />;
};

const App = () => {
  const screenSizeClass = useScreenSizeClass();
  const themeContext = useThemeContext();

  return (
    <Router>
      <ThemeContext.Provider value={themeContext}>
        <AuthProvider>
          <NavigationProvider>
            <div className={`app ${screenSizeClass}`}>
              <ProtectedRoute />
            </div>
          </NavigationProvider>
        </AuthProvider>
      </ThemeContext.Provider>
    </Router>
  );
};

export default App;
